import Vue from 'vue';
import * as types from '../mutation-types';
import router from '../../router';

const devEnv = process.env.NODE_ENV === 'development';
const temaId = 43;
const standardCategory = 'all';

// initial state
const state = {
  personCurrent: {},
  personIsAdmin: false,
  personIsAuth: true,
  category: standardCategory,
  tema: temaId,
  dev: devEnv,
  persons: [],
  person: {},
  busy: true,
};

// getters
const getters = {
  personBusy: stateFreezed => stateFreezed.busy,
  persons: stateFreezed => stateFreezed.persons,
  person: stateFreezed => stateFreezed.person,
  personIsAuth: stateFreezed => stateFreezed.personIsAuth,
  personIsAdmin: stateFreezed => stateFreezed.personIsAdmin,
  personCurrent: stateFreezed => stateFreezed.personCurrent,
  category: stateFreezed => stateFreezed.category,
  tema: stateFreezed => stateFreezed.tema,
  dev: stateFreezed => stateFreezed.dev,
};

// actions
/* eslint-disable */
const actions = {
  fetchPersons({ commit, dispatch, state }, position) {
    commit(types.RECEIVE_PERSONS, {});

    const tag = state.category === standardCategory ? '' : `&tag=${state.category}`;

    let offset = position > 0 ? position - 10 : 0;
    if (offset < 0) offset = 0;

    if (position !== null) {
      setTimeout(() => {
        Vue.http.get(`users/?offset=${offset}${tag}`)
        .then((response) => {
          if (response.body) {
            commit(types.RECEIVE_PERSONS, response.body);
          }
        }, 200);
      });
    }
  },

  fetchPersonsWithNewTag({ commit, dispatch, state }, position) {
    commit(types.RECEIVE_PERSONS, {});
    const tag = state.category === standardCategory ? '' : `&tag=${state.category}`;

    let offset = position > 0 ? position - 10 : 0;
    if (offset < 0) offset = 0;

    if (position == null) {
      setTimeout(() => {
        Vue.http.get(`users/?offset=${offset}${tag}`)
        .then((response) => {
          if (response.body) {
            dispatch('fetchPerson', response.body.results[1].id);
            setTimeout(() => {
              commit(types.RECEIVE_PERSONS, response.body);
            }, 1000);
          }
        }, 200);
      });
    }
  },

  fetchCurrentPerson({ commit }) {
    Vue.http.get('v1/whoami/')
    .then((response) => {
      commit(types.FETCH_CURRENT_PERSON, response.body);
    }, () => {
      commit(types.FETCH_CURRENT_PERSON, {});
    });
  },

  fetchPerson({ commit, state }, id) {
    if (state.person && id !== state.person.id) {
      Vue.http.get(`users/${id}/`)
      .then((response) => {
        commit(types.FETCH_PERSON, response.body);
        commit(types.BUSY_PERSON, false);
      }, () => {
        router.push('/404/')
      });
    }
  },

  updateFacebookOpenGraph({ commit }, id) {
    const fbxhr = new XMLHttpRequest();
    fbxhr.open('POST', `https://graph.facebook.com/?id=https://vkusomer.artlebedev.ru/accounts/${id}/&scrape=true`, true);
    fbxhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    fbxhr.send();
  },
};

// mutations
const mutations = {
  [types.RECEIVE_PERSONS](stateFreezed, personsFetched) {
    const st = stateFreezed;
    st.persons = personsFetched;
  },

  [types.FETCH_CURRENT_PERSON](stateFreezed, person) {
    const st = stateFreezed;
    st.personCurrent = person;
    st.personIsAuth = person.id > 0;
    st.personIsAdmin = person && person.id === st.tema;
    if (st.personIsAdmin) {
      this.dispatch('fetchFancyCounter');
    }

  },

  [types.CLEAR_PERSONS](stateFreezed) {
    const st = stateFreezed;
    st.busy = true;
    st.persons = [];
  },

  [types.FETCH_PERSON](stateFreezed, person) {
    const st = stateFreezed;
    st.person = person;
    let position = person.position;

    if (st.category !== standardCategory) {
      position = st.person.per_tag_stats ? st.person.per_tag_stats[st.category] : 0;
    }

    if (stateFreezed.persons.length <= 0) {
      if (person.compare_etalon > 0) {
        this.dispatch('fetchPersons', position);
      } else {
        this.dispatch('fetchPersons', 1);
      }
    }
  },

  [types.BUSY_PERSON](stateFreezed, busy) {
    const st = stateFreezed;
    st.busy = busy;
  },

  [types.SET_CATEGORY](stateFreezed, category) {
    const st = stateFreezed;
    st.category = category;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/persons.js